export default __webpack_public_path__ + "static/media/product_pref.e068c4c9b70d2df2e45ead0bcee4e721.svg";